/**
 * @typedef {(FIFTH | FIRST | FOURTH | SEVENTH | SIXTH | THIRD | ZERO)} TypeLevel A level.
 */

/**
 * The 'FIFTH' level.
 * @type {'fifth'}
 * @constant
 */
const FIFTH = 'fifth';

/**
 * The 'FIRST' level.
 * @type {'first'}
 * @constant
 */
const FIRST = 'first';

/**
 * The 'FOURTH' level.
 * @type {'fourth'}
 * @constant
 */
const FOURTH = 'fourth';

/**
 * The 'SEVENTH' level.
 * @type {'seventh'}
 * @constant
 */
const SEVENTH = 'seventh';

/**
 * The 'SIXTH' level.
 * @type {'sixth'}
 * @constant
 */
const SIXTH = 'sixth';

/**
 * The 'THIRD' level.
 * @type {'third'}
 * @constant
 */
const THIRD = 'third';

/**
 * The 'ZERO' level.
 * @type {'zero'}
 * @constant
 */
const ZERO = 'zero';

export {

    FIFTH,
    FIRST,
    FOURTH,
    SEVENTH,
    SIXTH,
    THIRD,
    ZERO
};
